"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _config = _interopRequireDefault(require("@gymshark/config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var logos = {
  symbolBlack: "".concat(_config["default"].cdn, "/images/branding/gs-icon-black.svg")
};
var _default = logos;
exports["default"] = _default;